 import CryptoJS from 'crypto-js';
 import CreateAnnexure from './createAnnexure';
 import CustomExpandableTable from '../../../../shared/components/customExpandableTable'
 import Pagination from './../../../../shared/components/pagination'
 import MasterService from './../../../../masterdata/services/masterdata.service';
 import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
 import CONSTANT from './../../../../shared/constants/constant';
 import Loader from '../../../../shared/components/loader';
 import Util from './../../../../shared/util/util';
 

export default {
  name: 'AnnexureListing',
  components: {
   CreateAnnexure,
   Pagination,
   Loader,
   CustomExpandableTable
  },
  props: ['selectedEdit','callingFromClientContract','contractidd'],
  data: function() {
    return {
      isLoading: false,
      showAnnexure: false,
      annexureinput: '',
      contractId: '',
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      resultCount:0,
      offset:0,
      tableColumn: ['Annexure Name', 'Description', 'Upload Date','FileName','Action'],
      tableItems: [],
      userName:''
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if (this.callingFromClientContract && this.callingFromClientContract.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
			if(this.callingFromClientContract.newlySelectedTemplateId){
        this.contractId = this.callingFromClientContract.id;
				this.getContractAnnexureListing(1);
			} else if(this.callingFromClientContract.existingContractTemplateId){
				//from Existing Client service details
        this.contractId = this.callingFromClientContract.id;
				this.getContractAnnexureListing(1);
			}
		} else {
      if (this.selectedEdit.length == 0) {
        this.contractId = this.selectedEdit.id || this.contractidd;
        if(this.contractId) {
          this.getContractAnnexureListing();
        }
      } else {
        this.contractId = this.selectedEdit.id ;
        this.getContractAnnexureListing();
      }
		}
  },
  methods: {
   showCreateAnnexure(){
     this.showAnnexure = true;
   },
   callParent() {
    this.showAnnexure = false;
    if (this.callingFromClientContract){
      this.getContractAnnexureListing(1);
    }else{
      this.getContractAnnexureListing();
    }
   },
   async removeAnnexureContractData(deleteId){
     try {
       this.isLoading = true;
       let inputPayload = {
         "id": deleteId,
         "lastmodifiedby": this.userName
       }
       let result;
       if (this.callingFromClientContract){
         result = await ClientService.removeClientAnnexureData(inputPayload);
         if(result.data.code == 200){
           this.$alert(result.data.message, this.companyName, "success");
           this.currentPage = 1;
           this.getContractAnnexureListing(1);
         }
       }else{
         result = await MasterService.removeAnnexureContractData(inputPayload)
         if(result.data.code == 200){
           this.$alert(result.data.message, this.companyName, "success");
           this.currentPage = 1;
           this.getContractAnnexureListing();
         }
       }
       this.isLoading = false;
     } catch(err){
       console.log(err);
       this.isLoading = false;
     }
   },
   async getContractAnnexureListing(clientcontractid){
     try {
       if(this.contractId!="")
       {
         this.isLoading = true;
         let inputPayload = {
           "offset": this.offset,
           "limit": this.pageLimit
         }
         let result;
         if(clientcontractid){
           inputPayload.clientcontractid = this.contractId;
           result = await ClientService.getClientAnnexureList(inputPayload);
         }else{
           inputPayload.contractid = this.contractId;
           result = await MasterService.getContractAnnexureListing(inputPayload);
         }
         this.AnnexureList = result.data.data.rows;
         this.tableItems=result.data.data.rows.map((data)=>{
          return {
             'id':data.id,
             'Annexure Name':data.annexurename,
             'Description':data.annexuredscription,
             'FileName':data.annexureurl,
             'Upload Date': Util.displayDateTimeFormat(data.createddate),
             'Action': 'Need To Check1',
           }
         })
         this.isLoading = false;
         this.totalCount = result.data.data.count;
         if (this.totalCount < this.pageLimit) {
           this.totalPage = 1;
         } else {
           this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
         }
       }
     } catch(err){
       console.log(err);
     }
   },
   fileview(index){
     var link = document.createElement('a');
     link.href = index;
     link.setAttribute('target','_blank');
     window.open(index, '_blank');
     link.remove();
     return true;
   },
   getCustomTableEvent(event) {
     if (event.actionType == "download"){
        var item = this.AnnexureList.find(item => item.id === event.id);
       this.fileview(item.annexureurl);
     }
     if (event.actionType == "delete") {
       this.$confirm("Are you sure you want to delete?","","question").then(() => {
       var item = this.AnnexureList.find(item => item.id === event.id);
        if(item.id){
          this.removeAnnexureContractData(item.id);
        }else{
           this.$alert("Please Provide Annexure Id",'', "error");
        }
      }).catch((err)=>{
        console.log(err)
      });
     }
   },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit; 
      if (this.callingFromClientContract){
        this.getContractAnnexureListing(1);
      }else{
        this.getContractAnnexureListing();
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/annexures/annexures.component.js